import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { PublishingListItem } from './PagedPublishingList';

@Injectable({
  providedIn: 'root'
})
export class PublishingService extends BaseService {
  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
  }
  
  GetPublications(publicationYear: string): Observable<PublishingListItem[]> {
    return this.Get<PublishingListItem[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Publishing/publication?year=${publicationYear}&statusFilter=Published`);
  }

  GetLatestPublication(): Observable<PublishingListItem> {
    return this.Get<PublishingListItem>(`${this.configParam.ApiConfig.API_ENDPOINT}Publishing/latestPublication?statusFilter=Published`);
  }
}
